export const ADMIN_NAV = {
  sidebar: 'admin-sidebar',
  dashboardLink: 'admin-nav-dashboard',
  employeesLink: 'admin-nav-employees',
  companyProfileLink: 'admin-nav-company-profile',
  consultingLink: 'admin-nav-consulting',
  auditLogLink: 'admin-nav-audit-log',
  nom035Link: 'admin-nav-nom035',
  logoutButton: 'admin-logout-button',
  mobileMenuButton: 'admin-mobile-menu-button',
  mobileDrawer: 'admin-mobile-drawer',
  usageGuideButton: 'admin-usage-guide-button',
};

export const ADMIN_DASHBOARD = {
  semaphore: 'admin-dashboard-semaphore',
  statTotalEmployees: 'admin-dashboard-stat-total-employees',
  statPendingPolicies: 'admin-dashboard-stat-pending-policies',
  statIncidents: 'admin-dashboard-stat-incidents',
  statHighRisk: 'admin-dashboard-stat-high-risk',
  statPendingVacations: 'admin-dashboard-stat-pending-vacations',
  statTrainingInvestment: 'admin-dashboard-stat-training-investment',
  unscheduledVacationBanner: 'admin-dashboard-unscheduled-vacation-banner',
  missingEmergencyContactBanner: 'admin-dashboard-missing-emergency-contact-banner',
  pendingCorrectionsBanner: 'admin-dashboard-pending-corrections-banner',
  signatureReminderBanner: 'admin-dashboard-signature-reminder-banner',
  failedEmailsBanner: 'admin-dashboard-failed-emails-banner',
  salarioMinimoBanner: 'admin-dashboard-salario-minimo-banner',
  missingPunchBanner: 'admin-dashboard-missing-punch-banner',
  earlyCheckoutBanner: 'admin-dashboard-early-checkout-banner',
  moduleTeaserCard: 'admin-dashboard-module-teaser-card',
  razonSocialInput: 'dashboard-razon-social-input',
  rfcInput: 'dashboard-rfc-input',
  domicilioInput: 'dashboard-domicilio-input',
  representanteLegalInput: 'dashboard-representante-legal-input',
  saveCompanyProfileButton: 'dashboard-save-company-profile-button',
  expectedCheckinTimeInput: 'dashboard-expected-checkin-time-input',
  expectedCheckinToleranceInput: 'dashboard-expected-checkin-tolerance-input',
  expectedCheckoutTimeInput: 'dashboard-expected-checkout-time-input',
  weeklyReportEmailInput: 'dashboard-weekly-report-email-input',
  weeklyReportDaySelect: 'dashboard-weekly-report-day-select',
  payrollPeriodicitySelect: 'dashboard-payroll-periodicity-select',
  payrollCycleStartDaySelect: 'dashboard-payroll-cycle-start-day-select',
  lateArrivalsThresholdInput: 'dashboard-late-arrivals-threshold-input',
  upcomingBirthdaysBanner: 'admin-dashboard-upcoming-birthdays-banner',
  upcomingAnniversariesBanner: 'admin-dashboard-upcoming-anniversaries-banner',
  statTotalPayroll: 'admin-dashboard-stat-total-payroll',
  attendanceCard: 'admin-dashboard-attendance-card',
};

export const PENDING_CONFIRMATIONS_PANEL = {
  section: 'pending-confirmations-panel-section',
  row: 'pending-confirmations-panel-row',
  kindBadge: 'pending-confirmations-panel-kind-badge',
  reminderBadge: 'pending-confirmations-panel-reminder-badge',
  emptyState: 'pending-confirmations-panel-empty-state',
  sendReminderButton: 'pending-confirmations-panel-send-reminder-button',
  lastReminderLabel: 'pending-confirmations-panel-last-reminder-label',
};

export const ADMIN_EMPLOYEES = {
  newEmployeeButton: 'admin-employees-new-button',
  employeeRow: 'admin-employee-row',
  searchInput: 'admin-employees-search-input',
  fullNameInput: 'employee-form-fullname-input',
  emailInput: 'employee-form-email-input',
  phoneInput: 'employee-form-phone-input',
  positionInput: 'employee-form-position-input',
  contractTypeSelect: 'employee-form-contract-type-select',
  hireDateInput: 'employee-form-hiredate-input',
  workCenterInput: 'employee-form-workcenter-input',
  curpInput: 'employee-form-curp-input',
  rfcInput: 'employee-form-rfc-input',
  nssInput: 'employee-form-nss-input',
  fechaNacimientoInput: 'employee-form-fecha-nacimiento-input',
  nacionalidadInput: 'employee-form-nacionalidad-input',
  domicilioInput: 'employee-form-domicilio-input',
  submitButton: 'employee-form-submit-button',
  devTempPasswordBanner: 'employee-dev-temp-password-banner',
  emailFailedBanner: 'employee-email-failed-banner',
};

export const ADMIN_EMPLOYEE_DETAIL = {
  tabPolicies: 'employee-detail-tab-policies',
  tabIncidents: 'employee-detail-tab-incidents',
  tabVacation: 'employee-detail-tab-vacation',
  tabSalary: 'employee-detail-tab-salary',
  tabAnnouncements: 'employee-detail-tab-announcements',
  tabCheckpoint: 'employee-detail-tab-checkpoint',
  tabBaja: 'employee-detail-tab-baja',
  tabReceipts: 'employee-detail-tab-receipts',
  tabDocuments: 'employee-detail-tab-documents',
  tabTraining: 'employee-detail-tab-training',
  askAdvisorButton: 'employee-detail-ask-advisor-button',
  correctionRequestsBanner: 'employee-detail-correction-requests-banner',
  resolveCorrectionRequestButton: 'employee-detail-resolve-correction-request-button',
  assignPolicyButton: 'employee-detail-assign-policy-button',
  policySelect: 'employee-detail-policy-select',
  confirmAssignButton: 'employee-detail-confirm-assign-button',
  newIncidentButton: 'employee-detail-new-incident-button',
  incidentDescriptionInput: 'incident-form-description-input',
  incidentDateInput: 'incident-form-date-input',
  incidentSubmitButton: 'incident-form-submit-button',
};

export const ACTA_ADMINISTRATIVA = {
  openButton: 'acta-open-button',
  dialog: 'acta-wizard-dialog',
  stepIndicator: 'acta-wizard-step-indicator',
  incidentCheckbox: 'acta-wizard-incident-checkbox',
  hechosTextarea: 'acta-wizard-hechos-textarea',
  fundamentoTextarea: 'acta-wizard-fundamento-textarea',
  testigoNombreInput: 'acta-wizard-testigo-nombre-input',
  testigoPuestoInput: 'acta-wizard-testigo-puesto-input',
  addTestigoButton: 'acta-wizard-add-testigo-button',
  removeTestigoButton: 'acta-wizard-remove-testigo-button',
  versionTrabajadorTextarea: 'acta-wizard-version-trabajador-textarea',
  fechaInput: 'acta-wizard-fecha-input',
  horaInput: 'acta-wizard-hora-input',
  lugarInput: 'acta-wizard-lugar-input',
  levantoInput: 'acta-wizard-levanto-input',
  backButton: 'acta-wizard-back-button',
  nextButton: 'acta-wizard-next-button',
  generateButton: 'acta-wizard-generate-button',
};

export const DOSSIER_EDIT = {
  openButton: 'dossier-edit-open-button',
  fieldInputPrefix: 'dossier-edit-field-input',
  saveButton: 'dossier-edit-save-button',
};

export const SALARY_TAB = {
  currentSalary: 'salary-tab-current-salary',
  newEntryButton: 'salary-tab-new-entry-button',
  salaryInput: 'salary-tab-salary-input',
  effectiveDateInput: 'salary-tab-effective-date-input',
  reasonInput: 'salary-tab-reason-input',
  submitButton: 'salary-tab-submit-button',
  historyRow: 'salary-tab-history-row',
  addComponentButton: 'salary-tab-add-component-button',
  componentNameInput: 'salary-tab-component-name-input',
  componentAmountInput: 'salary-tab-component-amount-input',
  componentPeriodicitySelect: 'salary-tab-component-periodicity-select',
  componentTagSelect: 'salary-tab-component-tag-select',
  componentIsrTaxableCheckbox: 'salary-tab-component-isr-taxable-checkbox',
  componentRemoveButton: 'salary-tab-component-remove-button',
  totalPreview: 'salary-tab-total-preview',
  sdiWarning: 'salary-tab-sdi-warning',
  visibilitySelect: 'salary-tab-visibility-select',
  periodicidadPagoSelect: 'salary-tab-periodicidad-pago-select',
  isrPreviewButton: 'salary-tab-isr-preview-button',
  isrPreviewCard: 'salary-tab-isr-preview-card',
  checkpointRequiresSalaryNotice: 'salary-tab-checkpoint-requires-salary-notice',
  isrAlert: 'salary-tab-isr-alert',
  isrDisclaimer: 'salary-tab-isr-disclaimer',
  isrHistoryCard: 'salary-tab-isr-history-card',
};

export const ANNOUNCEMENTS_HISTORY_TAB = {
  row: 'announcements-history-row',
};

export const TALENT_MAP = {
  employeeRow: 'talent-map-employee-row',
  flagBadge: 'talent-map-flag-badge',
  filterButton: 'talent-map-filter-button',
  exportCsvButton: 'talent-map-export-csv-button',
  evaluationsSection: 'talent-map-evaluations-section',
  evaluationCadenceSelect: 'talent-map-evaluation-cadence-select',
  evaluateButton: 'talent-map-evaluate-button',
  evaluationRow: 'talent-map-evaluation-row',
  evaluationDownloadPdfButton: 'talent-map-evaluation-download-pdf-button',
};

export const EVALUATION_DIALOG = {
  dialog: 'evaluation-dialog',
  periodLabelInput: 'evaluation-period-label-input',
  evaluationDateInput: 'evaluation-date-input',
  criterionScoreButton: 'evaluation-criterion-score-button',
  strengthsInput: 'evaluation-strengths-input',
  areasToImproveInput: 'evaluation-areas-to-improve-input',
  commentsInput: 'evaluation-comments-input',
  submitButton: 'evaluation-submit-button',
};

export const CONSULTING = {
  requestButton: 'consulting-request-button',
  contextInput: 'consulting-context-input',
  submitButton: 'consulting-submit-button',
  historyRow: 'consulting-history-row',
  markResolvedButton: 'consulting-mark-resolved-button',
};
export const CHECKPOINT_TAB = {
  disclaimer: 'checkpoint-disclaimer',
  pendingReviewBadge: 'checkpoint-pending-review-badge',
  integratedCost: 'checkpoint-integrated-cost',
  liquidationTotal: 'checkpoint-liquidation-total',
  liquidationBreakdownRow: 'checkpoint-liquidation-breakdown-row',
  conversationGuide: 'checkpoint-conversation-guide',
  missingSalaryNotice: 'checkpoint-missing-salary-notice',
  loadingIndicator: 'checkpoint-loading-indicator',
  trainingInvestmentCost: 'checkpoint-training-investment-cost',
  trainingInvestmentHours: 'checkpoint-training-investment-hours',
  causaSelect: 'checkpoint-causa-select',
  causaDescripcion: 'checkpoint-causa-descripcion',
  notAutoCalculableNotice: 'checkpoint-not-auto-calculable-notice',
};

export const PAYROLL_BREAKDOWN = {
  page: 'payroll-breakdown-page',
  totalPayroll: 'payroll-breakdown-total',
  row: 'payroll-breakdown-row',
  emptyState: 'payroll-breakdown-empty-state',
};

export const ATTENDANCE_TODAY = {
  page: 'attendance-today-page',
  row: 'attendance-today-row',
  emptyState: 'attendance-today-empty-state',
};

export const VACATION_CALENDAR = {
  container: 'vacation-calendar',
  prevMonthButton: 'vacation-calendar-prev-month',
  nextMonthButton: 'vacation-calendar-next-month',
  dayCell: 'vacation-calendar-day-cell',
};

export const TRAINING_SUMMARY = {
  page: 'training-summary-page',
  row: 'training-summary-row',
  totalCost: 'training-summary-total-cost',
  totalHours: 'training-summary-total-hours',
  emptyState: 'training-summary-empty-state',
};

export const TRAINING_TAB = {
  section: 'training-tab-section',
  addButton: 'training-tab-add-button',
  dateInput: 'training-form-date-input',
  topicInput: 'training-form-topic-input',
  costInput: 'training-form-cost-input',
  hoursInput: 'training-form-hours-input',
  providerInput: 'training-form-provider-input',
  submitButton: 'training-form-submit-button',
  row: 'training-tab-row',
  totalCost: 'training-tab-total-cost',
  totalHours: 'training-tab-total-hours',
  editButton: 'training-tab-edit-button',
  deleteButton: 'training-tab-delete-button',
  confirmDeleteButton: 'training-tab-confirm-delete-button',
  exportCsvButton: 'training-tab-export-csv-button',
  exportPdfButton: 'training-tab-export-pdf-button',
  companyComparison: 'training-tab-company-comparison',
};

export const BAJA_TAB = {
  citeIncidentCheckbox: 'baja-cite-incident-checkbox',
  noticeDateInput: 'baja-notice-date-input',
  generateNoticeButton: 'baja-generate-notice-button',
  noticePreview: 'baja-notice-preview',
  timingWarning: 'baja-timing-warning',
  markTerminatedButton: 'baja-mark-terminated-button',
  terminationDateInput: 'baja-termination-date-input',
  confirmTerminatedButton: 'baja-confirm-terminated-button',
  downloadCsvButton: 'baja-download-csv-button',
  downloadPdfButton: 'baja-download-pdf-button',
  noticeHistoryRow: 'baja-notice-history-row',
  causalSelect: 'baja-causal-select',
  huboPermisoCheckbox: 'baja-hubo-permiso-checkbox',
  huboJustificacionCheckbox: 'baja-hubo-justificacion-checkbox',
  fechaConocimientoInput: 'baja-fecha-conocimiento-input',
  draftLegalNotice: 'baja-draft-legal-notice',
};
